import React, { useState, useEffect } from 'react';

const pc = v => v == null ? '—' : (v >= 0 ? '+' : '') + Number(v).toFixed(2) + '%';
const col = v => v == null ? '#666' : v > 0 ? '#389e0d' : v < 0 ? '#cf1322' : '#666';

const ROWS = [
  ['1 day',   'chg_1d_pct'],  ['2 days',  'chg_2d_pct'],
  ['3 days',  'chg_3d_pct'],  ['5 days',  'chg_5d_pct'],
  ['7 days',  'chg_7d_pct'],  ['10 days', 'chg_10d_pct'],
  ['15 days', 'chg_15d_pct'], ['20 days', 'chg_20d_pct'],
];

const PriceProfile = ({ ticker, ltp, setupType }) => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let alive = true;
    fetch('/stats/profile/' + ticker)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(j => { if (alive) { if (j.error) setErr(true); else setD(j); } })
      .catch(() => { if (alive) setErr(true); });
    return () => { alive = false; };
  }, [ticker]);

  if (err) return <div style={{ fontSize: 11, color: '#999' }}>No price profile</div>;
  if (!d) return <div style={{ fontSize: 11, color: '#999' }}>Loading profile…</div>;

  const prev = Number(d.prev_close);
  const liveChg = (ltp && prev) ? ((ltp - prev) / prev) * 100 : null;
  const liveAbs = (ltp && prev) ? ltp - prev : null;

  return (
    <div style={{ fontSize: 12 }}>
      <div style={{ fontWeight: 600, marginBottom: 6 }}>
        Price profile
        <span style={{ fontWeight: 400, color: '#999', marginLeft: 6, fontSize: 11 }}>
          as of {d.for_date}
        </span>
      </div>

      <div style={{ marginBottom: 8, lineHeight: 1.7 }}>
        <div>Prev close <b>₹{prev ? prev.toFixed(2) : '—'}</b></div>
        {ltp && (
          <div>
            Today <b>₹{Number(ltp).toFixed(2)}</b>{' '}
            <span style={{ color: col(liveChg), fontWeight: 600 }}>
              {liveAbs >= 0 ? '+' : '−'}₹{Math.abs(liveAbs).toFixed(2)} ({pc(liveChg)})
            </span>
          </div>
        )}
      </div>

      <table style={{ borderCollapse: 'collapse' }}>
        <tbody>
          {ROWS.map(([label, key]) => {
            const trigger = (setupType === 'DIP' && key === 'chg_20d_pct');
            return (
              <tr key={key} style={trigger ? { background: '#fff7e6' } : undefined}>
                <td style={{ padding: '2px 12px 2px 0', color: '#666' }}>{label}</td>
                <td style={{ padding: '2px 0', textAlign: 'right',
                             color: col(d[key]), fontWeight: 600, minWidth: 64 }}>
                  {pc(d[key])}
                </td>
                {trigger && <td style={{ padding: '2px 8px', fontSize: 10, color: '#ad6800' }}>
                  ← DIP trigger (needs ≥ +20%)
                </td>}
              </tr>
            );
          })}
        </tbody>
      </table>

      <div style={{ marginTop: 8, color: '#666', lineHeight: 1.7 }}>
        Last 15 sessions: <b style={{ color: '#389e0d' }}>{d.green_days_15} green</b>
        {' / '}<b style={{ color: '#cf1322' }}>{d.red_days_15} red</b><br/>
        RSI14 <b>{d.rsi14 == null ? '—' : Number(d.rsi14).toFixed(0)}</b>
        {' · '}Vol vs 20d avg <b>{d.vol_ratio20 == null ? '—' : Number(d.vol_ratio20).toFixed(2)}x</b>
      </div>
    </div>
  );
};

export default PriceProfile;
